var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Company",
            "tabActive": "History",
            "bg": "/images/sub/visual/sv-company.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("History")])]), _c('div', {
    staticClass: "history-items"
  }, [_c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2024")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("미정")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("사옥 이전 예정")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2023")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("11.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("자회사 유진 설립")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("07.15")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v(" 법인사옥 매입 "), _c('br'), _vm._v(" 소재지 : 광진구 능동로 50길 8 (우성빌딩) ")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("02.24")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("자회사 유스트레이딩 설립")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("01.30")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("GLOBAL RECYCLED STANDARD(GRS)")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("ORGANIC COTTON STANDARD(OCS)")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("BETTER COTTON INITIATIVE(BCI)")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("친환경 인증 적용")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2022")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("06.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("자회사 연구소로 전환")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("법인 홈페이지 개설")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("신설 법인 설립(소재지 : 서울, 광진구)")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("01.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("법인 관리. 생산을 위한 ERP 시스템 구축")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2021")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("12.31")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("매출 200% 달성")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("10.28")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("IBK 베스트 파트너(BEST PARTNER)로 지정 - 수출우수기업 인증")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("10.14")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("인력 양성 사업에 관한 HRD 역량 강화 프로그램 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("컨소시엄과 MOU 체결")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("서울특별시 인재개발원과 상공회의소")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("06.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("계열사 사업부 신설")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2020")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("09.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("법인 건물 매입 [소재지 : 광진구 능동로 344 (동진빌딩)]")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2018")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("12.05")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("한국무역협회 가입")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("11.22")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("해외 법인명 변경 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("(주)샤오텍스타일")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2015")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("03.10")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("해외 법인 ㈜샤오텍스 (SHAOTEX Co., LIMITED) 설립")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2014")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("07.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("법인명을 유니텍스 코퍼레이션에서 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("→ (주)메이텍스타일(Meitextile Co., Ltd.)로 변경")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2010")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("00.00")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("유니텍스 코퍼레이션(Unitex Corp.) 설립")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2000")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("00.00")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("유니워스 코퍼레이션(Uniworth Corp.) 설립")])], 1)], 1)], 1)], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }